import React, {useState} from "react";
import Walkthrough from "./Walkthrough";

const TrailWalkthroughResults = props => {
    const {step, stepActivities} = props;
    const [activeQuestionId, setActiveQuestionId] = useState(null);

    return (
        <>
            {!activeQuestionId ? (
                <ul>
                    {stepActivities.map((stepActivity, i) => {
                        return (
                            <li key={i}>
                                <a onClick={() => setActiveQuestionId(stepActivity.questionId)}>
                                    {stepActivity.stepActivityName}
                                </a>
                            </li>
                        )
                    })}
                </ul>
            ) : (
                <Walkthrough
                    questionId={activeQuestionId}
                    conceptId={step?.conceptId}
                    showBackBtn={true}
                    showRestartBtn={true}
                    onBack={() => setActiveQuestionId(null)}
                />
            )}
        </>
    )
}

export default TrailWalkthroughResults;